define('views/merchants/map/control',[
    "backbone",
    "text!views/merchants/map/control.html",
    "views/_base/baseview"
], function (Backbone, Template, BaseView) {
    "use strict";

    return BaseView.extend({
        template   : _.template(Template),
        tagName    : "div",
        className  : 'map-controls',
        isRender   : true,
        needsAuth  : false,
        scrollToTop: false,
        events     : {
            '#zoomIn' : 'zoomIn',
            '#zoomOut': 'zoomOut'
        },
        initialize: function(options) {
            this.type = options.type;
            BaseView.prototype.initialize(this);
        },

        render: function() {
            this.$el.html(this.template());
            this.$el.addClass(this.type);
            return this;
        },

        handleZoomEvent: function(e){},

        zoomIn: function(map){
            var zoom = map.getZoom(),
                newZoom = zoom + 2;
            map.setZoom(newZoom);
        },

        zoomOut: function(map){
            var zoom = map.getZoom(),
                newZoom = zoom - 2;
            map.setZoom(newZoom);
        }

    });
});
